import { useState } from "react";
import { Flex, Input, List, Text } from "@theorgchartdev/storybook";
import type { ListItemOption } from "@theorgchartdev/storybook";
import { useTopic } from "@/hooks/useTopic";
import { useRouteState } from "@/hooks/useRouteState";
import { GetDoc } from "@/Utils/StateLib";
import { appstr } from "@coreapp/utils/appstr";
import { flattenSubchartTree, handleSubChartClick } from "@/Utils/subchartNav";

type SubchartRow = { label: string; value: string | number };

export const ChartNavigatorPanel = () => {
  const { setParam: setRouteParam } = useRouteState();
  const [, forceRender] = useState(0);
  const [filter, setFilter] = useState("");

  // Rebuild the list when a new chart loads; refresh the active highlight on subchart switch.
  useTopic("chartDocumentLoaded", () => forceRender(n => n + 1));
  useTopic("subchartSwitch", () => forceRender(n => n + 1));

  const doc = GetDoc();
  const scm = doc?.GetSubChartMgr();
  const rootSubChart = scm?.GetRootSubChart();
  const currentId = scm?.GetCurrentSubChartID?.();

  const items: SubchartRow[] = rootSubChart ? flattenSubchartTree(rootSubChart) : [];
  const normalizedFilter = filter.trim().toLowerCase();
  const options: ListItemOption[] = (
    normalizedFilter
      ? items.filter(item => (item.label ?? "").toLowerCase().includes(normalizedFilter))
      : items
  ).map(item => ({ label: item.label, value: item.value }));

  return (
    <Flex direction="column" gap="8px" padding="16px" height="100%" style={{ minHeight: 0 }}>
      <Input
        size="medium"
        value={filter}
        placeholder={appstr("Search")}
        onChange={(_: unknown, value: string) => setFilter(value)}
      />
      <Flex direction="column" flex="1" overflow="auto" style={{ minHeight: 0 }}>
        {options.length === 0 ? (
          <Flex padding="24px 16px" justifyContent="center">
            <Text colorModifier="grey" size="small">
              {appstr("No results")}
            </Text>
          </Flex>
        ) : (
          <List
            options={options}
            value={currentId}
            optionSize="small"
            listWidth="fill"
            enableHoverBackground
            enableKeyboardCursor
            enableVirtualization={false}
            onSelect={(option: ListItemOption) =>
              handleSubChartClick(doc, scm, option.value, setRouteParam)
            }
          />
        )}
      </Flex>
    </Flex>
  );
};
